module.exports = __webpack_public_path__ + "static/media/july-2022.64c33778.svg";